module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/restaurants_5-a9d4d8b5e7dc82cc53bc6ad79d69a2bd.jpg";